import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Y si no funciona o no me gusta?',
    answer: 'Tenés 7 días para probarlo. Si no te encanta, nos escribís y te devolvemos el 100% de tu dinero. Sin preguntas, sin vueltas.'
  }, {
    question: '¿Voy a poder hacerlo si nunca entrené?',
    answer: 'Sí. El programa está pensado desde cero. Cada ejercicio tiene videos demostrativos paso a paso y modificaciones para que arranques a tu ritmo.'
  }, {
    question: '¿Sirve si tengo poco tiempo?',
    answer: 'Sí. Las rutinas son de 20 a 30 minutos. Si podés sacarte ese tiempo 4 días a la semana, ya estás 🤍'
  }, {
    question: '¿En cuánto tiempo voy a ver resultados?',
    answer: 'La mayoría empieza a notar cambios entre la semana 2 y la 3 (energía, hinchazón, ropa que entra distinto). A los 28 días el cambio es visible.'
  }, {
    question: '¿Necesito equipamiento?',
    answer: 'No. Todo se hace desde casa usando tu propio peso corporal y una pared. Sin pesas, sin máquinas, sin gym.'
  }, {
    question: '¿Sirve para bajar de peso?',
    answer: 'Sí. El programa combina entrenamiento + alimentación, justo lo que necesitás para tonificar, bajar grasa y sostenerlo en el tiempo.'
  }, {
    question: '¿Cuándo recibo el material?',
    answer: 'Al instante. Apenas hacés la compra te llega todo por mail (programa + 10 bonos). Acceso inmediato y para siempre.'
  }];
  return <section className="py-12 md:py-16 bg-white" data-id="element-87">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-88">
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-center mb-12 text-gray-900" data-id="element-89">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-90">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-gray-200 rounded-2xl shadow-sm hover:shadow-md transition-shadow" data-id="element-91">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left" aria-expanded={openIndex === i} data-id="element-92">
                <span className="font-bold text-lg md:text-xl text-gray-900 pr-4" data-id="element-93">
                  {faq.question}
                </span>
                {openIndex === i ? <MinusIcon className="w-6 h-6 text-brand-pink-600 flex-shrink-0" data-id="element-94" /> : <PlusIcon className="w-6 h-6 text-brand-pink-600 flex-shrink-0" data-id="element-95" />}
              </button>
              {openIndex === i && <div className="px-6 pb-6" data-id="element-96">
                  <p className="text-gray-700 text-lg" data-id="element-97">{faq.answer}</p>
                </div>}
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-98">
          <CTAButton size="large" data-id="element-99">QUIERO EMPEZAR AHORA</CTAButton>
        </div>
      </div>
    </section>;
}